import { apiSimulator } from './api-simulator.service';
import { PlayerProfile } from '../models/player-profile';

export const playerProfileApi = {
  get(playerDefinitionId: string): Promise<PlayerProfile> {
    return apiSimulator.callWithMockFallback<PlayerProfile>({
      method: 'GET',
      endpoint: `/api/players/${encodeURIComponent(playerDefinitionId)}/profile`,
      service: 'players',
      mockName: 'profile',
      allowMockFallback: false,
    });
  },
};
